import { render } from "./StyleCardBrands.vue?vue&type=template&id=8c91d464"
import script from "./StyleCardBrands.vue?vue&type=script&lang=js"
export * from "./StyleCardBrands.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/StyleCard/StyleCardBrands.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8c91d464"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8c91d464', __exports__)) {
    api.reload('8c91d464', __exports__)
  }
  
  module.hot.accept("./StyleCardBrands.vue?vue&type=template&id=8c91d464", () => {
    api.rerender('8c91d464', render)
  })

}


export default __exports__